module.exports = __webpack_public_path__ + "static/media/img_no_access.3f6306f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/img_no_access.svg
// module id = 5273
// module chunks = 0